import { Routes } from "@angular/router";

export const howItWorksRoutes: Routes = [
    {
        path: 'how-it-works-old',
        title: 'How it works',
        loadComponent: () => import('./how-it-works.component').then(m => m.HowItWorksComponent),
        children: [
            {
                path: 'main',
                title: 'How it works',
                loadComponent: () => import('./main/main.component').then(m => m.MainComponent)
            },
            {
                path: 'product-tags-and-navigation',
                title: 'Product tags and navigation',
                loadComponent: () => import('./product-tags-and-navigation/product-tags-and-navigation.component').then(m => m.ProductTagsAndNavigationComponent)
            },
            {
                path: 'rewards-program',
                title: 'Roots rewards program',
                loadComponent: () => import('./rewards-program/rewards-program.component').then(m => m.RewardsProgramComponent)
            },
            {
                path: 'produce-program',
                title: 'Low cost produce program',
                loadComponent: () => import('./produce-program/produce-program.component').then(m => m.ProduceProgramComponent)
            },
        ]
    }
];
